import classNames from 'classnames/bind';
import styles from '../RenderCell.module.css';
const stylesContext = classNames.bind(styles);

interface StackedTextCellProps {
	/** Primary data point of the cell [Top Position] */
	primaryText?: string;
	primaryClassName?: string;
	/** Secondary data point of the cell [Bottom Position] */
	secondaryText?: string;
	secondaryClassName?: string;
}

/**
 * Custom Cell plugged into the MUI Data Grid Pro Cell Renderer function to render two data points
 * stacked on top of eachother. The Primary text is more prominent than the Secondary text.
 */
export default function StackedTextCell(props: StackedTextCellProps) {
	const primaryStyles = stylesContext({
		'stacked-text-cell-primary-slot': true,
		[props.primaryClassName ?? '']: Boolean(props.primaryClassName)
	});

	const secondaryStyles = stylesContext({
		'stacked-text-cell-secondary-slot': true,
		[props.secondaryClassName ?? '']: Boolean(props.secondaryClassName)
	});

	return (
		<>
			<span
				className={primaryStyles}
				title={props.primaryText}
			>
				{props.primaryText}
			</span>
			<span
				className={secondaryStyles}
				title={props.secondaryText}
			>
				{props.secondaryText}
			</span>
		</>
	);
}
